
const mixin = {
  methods: {
    setPageTitle (title) {
      this.$store.dispatch('pageSettings/setPageTitle', title)
    },

    startPageLoading () {
      this.$store.dispatch('pageSettings/setPageLoading', true)
    },

    stopPageLoading () {
      this.$store.dispatch('pageSettings/setPageLoading', false)
    }
  },

  beforeRouteLeave (to, from, next) {
    this.$store.dispatch('pageSettings/setPageLoading', false)
    next()
  }
}

export default mixin
